/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrariPianificazioneResDto } from '../../models/orari-pianificazione-res-dto';

export interface OrariPianificazioniControllerCreateOrarioPianificazione$Params {
  body: OrariPianificazioneResDto;
}

export function orariPianificazioniControllerCreateOrarioPianificazione(
  http: HttpClient,
  rootUrl: string,
  params: OrariPianificazioniControllerCreateOrarioPianificazione$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<OrariPianificazioneResDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    orariPianificazioniControllerCreateOrarioPianificazione.PATH,
    'post',
  );
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OrariPianificazioneResDto>;
      }),
    );
}

orariPianificazioniControllerCreateOrarioPianificazione.PATH =
  '/admin/orarioPianificazione';
